module.exports = __webpack_public_path__ + "static/UI-UX-Consultant-f80743f636d7c0e4391ed7d02df27924.png";